import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiGet, apiPost, apiPatch } from '../api/client';

export default function Funcionarios() {
    const [lista, setLista]         = useState([]);
    const [loading, setLoading]     = useState(true);
    const [form, setForm]           = useState({ nome: '', email: '', senha: '', role: 'funcionario' });
    const [salvando, setSalvando]   = useState(false);
    const [erro, setErro]           = useState('');
    const [sucesso, setSucesso]     = useState('');

    const carregar = () => {
        setLoading(true);
        apiGet('/api/admin/funcionarios').then(res => {
            if (res?.success) setLista(res.data.dados);
            setLoading(false);
        });
    };

    useEffect(() => { carregar(); }, []);

    const salvar = async () => {
        setErro(''); setSucesso('');
        setSalvando(true);
        const res = await apiPost('/api/admin/funcionarios', form);
        if (res?.success) {
            setForm({ nome: '', email: '', senha: '', role: 'funcionario' });
            setSucesso('Funcionário cadastrado com sucesso.');
            carregar();
        } else {
            setErro(res?.errors?.join(' ') || 'Erro ao cadastrar.');
        }
        setSalvando(false);
    };

    const alterarAtivo = async (id, ativo) => {
        const res = await apiPatch(`/api/admin/funcionarios/${id}`, { ativo });
        if (res?.success) carregar();
    };

    return (
        <Layout>
            <h1 style={{ margin: '0 0 24px', fontSize: '24px', color: '#1B2631' }}>Funcionários</h1>

            {/* Formulário */}
            <div style={{ background: '#fff', borderRadius: '10px', padding: '24px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <h2 style={{ margin: '0 0 16px', fontSize: '16px', color: '#2C3E50' }}>Novo funcionário</h2>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr 1fr', gap: '12px' }}>
                    <div>
                        <label style={label}>Nome</label>
                        <input type="text" value={form.nome} maxLength={120}
                            onChange={e => setForm(f => ({...f, nome: e.target.value}))}
                            style={input} placeholder="Nome completo" />
                    </div>
                    <div>
                        <label style={label}>E-mail</label>
                        <input type="email" value={form.email}
                            onChange={e => setForm(f => ({...f, email: e.target.value}))}
                            style={input} placeholder="email@empresa.com" />
                    </div>
                    <div>
                        <label style={label}>Senha</label>
                        <input type="password" value={form.senha}
                            onChange={e => setForm(f => ({...f, senha: e.target.value}))}
                            style={input} placeholder="Mínimo 8 caracteres" />
                    </div>
                    <div>
                        <label style={label}>Perfil</label>
                        <select value={form.role}
                            onChange={e => setForm(f => ({...f, role: e.target.value}))}
                            style={input}>
                            <option value="funcionario">Funcionário</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                </div>

                {erro    && <div style={{ color: '#922B21', fontSize: '13px', marginTop: '10px' }}>{erro}</div>}
                {sucesso && <div style={{ color: '#1E8449', fontSize: '13px', marginTop: '10px' }}>{sucesso}</div>}

                <button onClick={salvar} disabled={salvando} style={{
                    marginTop: '16px', padding: '10px 24px',
                    background: salvando ? '#AED6F1' : '#1B4F72',
                    color: '#fff', border: 'none', borderRadius: '6px',
                    cursor: salvando ? 'not-allowed' : 'pointer',
                    fontWeight: '600', fontSize: '14px',
                }}>
                    {salvando ? 'Salvando...' : 'Cadastrar'}
                </button>
            </div>

            {/* Tabela */}
            <div style={{ background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                {loading ? <LoadingSpinner /> : (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ background: '#F8F9FA', borderBottom: '2px solid #EAECEE' }}>
                                {['Nome', 'E-mail', 'Perfil', 'Último login', 'Status', 'Ações'].map(h => (
                                    <th key={h} style={th}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map(u => (
                                <tr key={u.id} style={{ borderBottom: '1px solid #F0F0F0', opacity: u.ativo ? 1 : 0.5 }}>
                                    <td style={td}>{u.nome}</td>
                                    <td style={td}>{u.email}</td>
                                    <td style={td}>
                                        <span style={{
                                            background: u.role === 'admin' ? '#EAF4FB' : '#F4F6F7',
                                            color:      u.role === 'admin' ? '#1A5276' : '#566573',
                                            padding: '2px 8px', borderRadius: '10px',
                                            fontSize: '12px', fontWeight: '600',
                                        }}>
                                            {u.role}
                                        </span>
                                    </td>
                                    <td style={td}>{u.ultimo_login || '—'}</td>
                                    <td style={td}>
                                        <span style={{
                                            background: u.ativo ? '#EAF7EA' : '#FDEDEC',
                                            color:      u.ativo ? '#1E8449' : '#922B21',
                                            padding: '2px 8px', borderRadius: '10px',
                                            fontSize: '12px', fontWeight: '600',
                                        }}>
                                            {u.ativo ? 'Ativo' : 'Inativo'}
                                        </span>
                                    </td>
                                    <td style={td}>
                                        <button
                                            onClick={() => alterarAtivo(u.id, u.ativo ? 0 : 1)}
                                            style={{
                                                padding: '4px 12px', fontSize: '12px',
                                                borderRadius: '6px', border: 'none',
                                                cursor: 'pointer', fontWeight: '600',
                                                background: u.ativo ? '#FDEDEC' : '#EAF7EA',
                                                color:      u.ativo ? '#922B21' : '#1E8449',
                                            }}
                                        >
                                            {u.ativo ? 'Desativar' : 'Ativar'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </Layout>
    );
}

const label = { display: 'block', fontSize: '13px', fontWeight: '600', color: '#2C3E50', marginBottom: '5px' };
const input = { width: '100%', padding: '8px 10px', border: '1px solid #D5D8DC', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
const th = { padding: '10px 14px', textAlign: 'left', fontSize: '12px', fontWeight: '700', color: '#566573', textTransform: 'uppercase' };
const td = { padding: '12px 14px', fontSize: '14px', color: '#2C3E50' };